import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/about/")({
  head: () => routeHead("/uk/about/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <About />
  );
}
